import React from 'react';
import { BrowserRouter as Router, Route/*, Link*/ } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';

// import logo from './logo.svg';
import './App.css';

import Playground from './components/Playground';

const About = () => <div><h2>About</h2></div>;

const App = () => (
    <Router history={ createHistory({ basename: process.env.PUBLIC_URL }) }>
        <div className="App">
            {/*<header className="App-header">
                <img src={logo} className="App-logo" alt="logo" />
                <h1 className="App-title">Welcome to React</h1>
            </header>
            <p className="App-intro">
                To get started, edit <code>src/App.js</code> and save to reload.
            </p>*/}
            {/*<ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/topics">Topics</Link></li>
            </ul>

            <hr/>*/}

            <Route exact path={ `${ process.env.PUBLIC_URL }/` } component={ Playground }/>
            <Route path={ `${ process.env.PUBLIC_URL }/about` } component={ About }/>
        </div>
    </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js